'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var constant = function constant(c) {
  return function () {
    return c;
  };
};
var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
  return keys.reduce(function (build, key) {
    build[keyFn ? keyFn(key) : key] = fn(key);
    return build;
  }, {});
};

function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

function isPromise(object) {
  return ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' || typeof object === 'function') && typeof object.then === 'function';
}

function isNested(ruleset) {
  return isObject(ruleset) && !ruleset.__isVuelidateAsyncVm;
}

var _cachedVue = null;
function getVue(rootVm) {
  if (_cachedVue) return _cachedVue;
  var Vue = rootVm.constructor;
  while (Vue.super) {
    Vue = Vue.super;
  }_cachedVue = Vue;
  return Vue;
}

var getPath = function getPath(ctx, obj, path, fallback) {
  if (typeof path === 'function') {
    return path.call(ctx, obj, fallback);
  }

  path = Array.isArray(path) ? path : path.split('.');
  for (var i = 0; i < path.length; i++) {
    if (isObject(obj)) {
      obj = obj[path[i]];
    } else {
      return fallback;
    }
  }

  return typeof obj === 'undefined' ? fallback : obj;
};

function setDirtyRecursive(newState) {
  this.dirty = newState;
  var method = newState ? '$touch' : '$reset';
  var keys = this.dynamicKeys;
  for (var i = 0; i < keys.length; i++) {
    var ruleOrNested = keys[i];
    var val = this[ruleOrNested];
    if (isNested(val)) {
      val[method]();
    }
  }
}

var defaultMethods = {
  $touch: function $touch() {
    setDirtyRecursive.call(this, true);
  },
  $reset: function $reset() {
    setDirtyRecursive.call(this, false);
  }
};

var defaultComputed = {
  $invalid: function $invalid() {
    var _this = this;

    return this.dynamicKeys.some(function (ruleOrNested) {
      var val = unwrapMaybeAsync(_this, ruleOrNested);
      return isObject(val) ? val.$invalid : !val;
    });
  },
  $dirty: function $dirty() {
    if (this.dirty) {
      return true;
    }
    var keys = this.dynamicKeys;

    var foundNested = false;
    for (var i = 0; i < keys.length; i++) {
      var ruleOrNested = keys[i];
      var val = this[ruleOrNested];
      var nested = isNested(val);
      foundNested = foundNested || nested;
      if (nested && !val.$dirty) {
        return false;
      }
    }
    return foundNested;
  },
  $error: function $error() {
    return !!(!this.$pending && this.$dirty && this.$invalid);
  },
  $pending: function $pending() {
    var _this2 = this;

    return this.dynamicKeys.some(function (ruleOrNested) {
      var val = _this2[ruleOrNested];
      if (val.__isVuelidateAsyncVm) {
        return val.pending;
      }
      return isNested(val) ? val.$pending : false;
    });
  }
};

var defaultMethodKeys = Object.keys(defaultMethods);
var defaultComputedKeys = Object.keys(defaultComputed);
var mapDynamicKeyName = function mapDynamicKeyName(k) {
  return 'v$$' + k;
};

function isSingleRule(ruleset) {
  return typeof ruleset === 'function';
}

function makePendingAsyncVm(Vue, promise) {
  var asyncVm = new Vue({
    data: {
      pending: true,
      value: false
    }
  });

  promise.then(function (value) {
    asyncVm.pending = false;
    asyncVm.value = value;
  }, function (error) {
    asyncVm.pending = false;
    asyncVm.value = false;
    throw error;
  });

  asyncVm.__isVuelidateAsyncVm = true;
  return asyncVm;
}

function makeValidationVm(validations, parentVm) {
  var rootVm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : parentVm;
  var parentProp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var validationKeys = Object.keys(validations).filter(function (key) {
    return !!validations[key];
  });
  var dynamicKeys = validationKeys.map(mapDynamicKeyName);

  var computedRules = buildFromKeys(validationKeys, function (key) {
    var rule = validations[key];
    return mapValidator(rootVm, rule, key, parentVm, parentProp);
  }, mapDynamicKeyName);

  var Vue = getVue(rootVm);

  var validationVm = new Vue({
    data: {
      dirty: false,
      dynamicKeys: dynamicKeys
    },
    methods: defaultMethods,
    computed: _extends({}, computedRules, defaultComputed)
  });

  return proxyVm(validationVm, validationKeys);
}

function mapValidator(rootVm, rule, ruleKey, vm, vmProp) {
  if (isSingleRule(rule)) {
    return mapRule(rootVm, rule, ruleKey, vm, vmProp);
  } else if (Array.isArray(rule)) {
    return mapGroup(rootVm, rule, ruleKey, vm, vmProp);
  } else {
    return mapChild(rootVm, rule, ruleKey, vm, vmProp);
  }
}

function unwrapMaybeAsync(vm, dynamicKey) {
  var val = vm[dynamicKey];
  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && val.__isVuelidateAsyncVm) {
    return val.value;
  }
  return val;
}

function mapRule(rootVm, rule, ruleKey, parentVm, prop) {
  return function () {
    var validatorOutput = rule.call(rootVm, parentVm[prop], parentVm);

    if (isPromise(validatorOutput)) {
      return makePendingAsyncVm(getVue(rootVm), validatorOutput);
    }

    if (isObject(validatorOutput) && validatorOutput.__isVuelidateVm) {
      return validatorOutput;
    }

    return !!validatorOutput;
  };
}

function mapChild(rootVm, rules, ruleKey, parentVm, prop) {
  if (ruleKey === '$each') {
    return trackCollection(rootVm, rules, parentVm, prop);
  }
  var childVm = typeof prop === 'string' ? parentVm[prop] : parentVm;
  var vm = makeValidationVm(rules, childVm, rootVm, ruleKey);
  return constant(vm);
}

function trackCollection(rootVm, eachRule, parentVm, prop) {
  var vmList = {};
  var strippedRule = _extends({}, eachRule, {
    $trackBy: undefined
  });

  return function () {
    var childVm = typeof prop === 'string' ? parentVm[prop] : parentVm;
    var newKeys = Object.keys(childVm);
    var keyToTrack = typeof eachRule.$trackBy !== 'undefined' ? buildFromKeys(newKeys, function (key) {
      return getPath(rootVm, childVm[key], eachRule.$trackBy);
    }) : null;

    var vmByKey = {};
    vmList = newKeys.reduce(function (newList, key) {
      var track = keyToTrack ? keyToTrack[key] : key;
      vmByKey[key] = newList[track] = newList[track] || vmList[track] || mapValidator(rootVm, strippedRule, key, childVm);
      return newList;
    }, {});

    return makeValidationVm(vmByKey, childVm, rootVm);
  };
}

function mapGroup(rootVm, group, prop, parentVm) {
  var rules = buildFromKeys(group, function (path) {
    return function () {
      return getPath(this, this.$v, path);
    };
  });

  var vm = makeValidationVm(rules, parentVm, rootVm, prop);
  return constant(vm);
}

function proxyVm(vm, originalKeys) {
  var redirectDef = _extends({}, buildFromKeys(originalKeys, function (key) {
    var dynKey = mapDynamicKeyName(key);
    return {
      enumerable: true,
      get: function get() {
        return unwrapMaybeAsync(vm, dynKey);
      }
    };
  }), buildFromKeys(defaultComputedKeys, function (key) {
    return {
      enumerable: true,
      get: function get() {
        return vm[key];
      }
    };
  }), buildFromKeys(defaultMethodKeys, function (key) {
    return {
      value: vm[key].bind(vm)
    };
  }), {
    __isVuelidateVm: {
      configurable: false,
      enumerable: false,
      value: true
    }
  });

  return Object.defineProperties({}, redirectDef);
}

var validationMixin = {
  beforeCreate: function beforeCreate() {
    var _this3 = this;

    var options = this.$options;
    if (!options.validations) return;
    var validations = options.validations;

    if (typeof options.computed === 'undefined') {
      options.computed = {};
    }

    options.computed.$v = function () {
      return validateModel(_this3, validations);
    };
  }
};

var validateModel = function validateModel(model, validations) {
  return makeValidationVm(validations, model);
};

function Validation(Vue) {
  if (Validation.installed) {
    return;
  }
  _cachedVue = Vue;
  Vue.mixin(validationMixin);
}

exports.Validation = Validation;
exports.validationMixin = validationMixin;
exports.validateModel = validateModel;
exports.default = Validation;


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/index.js
// module id = ./node_modules/vuelidate/lib/index.js
// module chunks = 2